var $ = require("jquery");

function strengthScore(password, minLen) {
  if (!password.length) return 0;
  var s = 0;
  if (password.length >= minLen) s++;
  if (/[A-Za-z]/.test(password)) s++;
  if (/\d/.test(password)) s++;
  return s;
}

function syncConfirmationValidity($root, passwordEl, confirmationEl) {
  if (!confirmationEl) return;
  var v = confirmationEl.value;
  var p = passwordEl ? passwordEl.value : "";
  var mismatch = $root.data("passwordMismatch") || "Passwords do not match";
  confirmationEl.setCustomValidity(v && v !== p ? mismatch : "");
}

function updateStrengthUI($root, password, minLen) {
  var score = strengthScore(password, minLen);
  var widthPct = password.length ? (score / 3) * 100 : 0;

  var $fill = $root.find(".v2-password-strength__fill");
  var mod =
    "v2-password-strength__fill--empty v2-password-strength__fill--weak v2-password-strength__fill--medium v2-password-strength__fill--strong";
  $fill.removeClass(mod);
  if (!password.length) {
    $fill.addClass("v2-password-strength__fill--empty");
  } else if (score <= 1) {
    $fill.addClass("v2-password-strength__fill--weak");
  } else if (score === 2) {
    $fill.addClass("v2-password-strength__fill--medium");
  } else {
    $fill.addClass("v2-password-strength__fill--strong");
  }
  $fill.css("width", widthPct + "%");

  var label = "";
  if (password.length) {
    if (score <= 1) label = $root.data("strengthWeak") || "Weak";
    else if (score === 2) label = $root.data("strengthMedium") || "Medium";
    else label = $root.data("strengthStrong") || "Strong";
  }
  var $label = $root.find(".v2-password-strength__label");
  $label.text(label);
  $label.toggle(!!label);

  var hasMinLen = password.length >= minLen;
  var hasLetter = /[A-Za-z]/.test(password);
  var hasNumber = /\d/.test(password);

  function setRule(name, ok) {
    var $icon = $root.find(".js-v2-pwd-rule-" + name);
    var $mark = $root.find(".js-v2-pwd-rule-" + name + "-mark");
    $icon.toggleClass("v2-password-strength__check-icon--ok", ok);
    $icon.toggleClass("v2-password-strength__check-icon--pending", !ok);
    $mark.toggle(ok);
  }

  setRule("min", hasMinLen);
  setRule("letter", hasLetter);
  setRule("number", hasNumber);
}

function refreshRoot($root) {
  var pwdId = $root.data("passwordId");
  var confId = $root.data("confirmationId");
  var minLen = parseInt($root.data("minLength"), 10);
  if (!pwdId || !confId || !minLen) return;

  var passwordEl = document.getElementById(pwdId);
  var confirmationEl = document.getElementById(confId);
  if (!passwordEl || !confirmationEl) return;

  var pwd = passwordEl.value || "";
  updateStrengthUI($root, pwd, minLen);
  syncConfirmationValidity($root, passwordEl, confirmationEl);
}

$(document).on(
  "input.v2pwdval",
  ".v2-password-with-validation input[type='password']",
  function () {
    var $root = $(this).closest(".v2-password-with-validation");
    if ($root.length) refreshRoot($root);
  }
);

function initV2PasswordValidations() {
  $(".v2-password-with-validation").each(function () {
    refreshRoot($(this));
  });
}

module.exports = initV2PasswordValidations;
